"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54,0H.74A.75.75,0,0,0,0,.75V20.57a.76.76,0,0,0,.75.75H2.45a3.89,3.89,0,0,0,7.39,0h.52a3.89,3.89,0,0,0,7.39,0H36.68a3.89,3.89,0,0,0,7.39,0h.52a3.89,3.89,0,0,0,7.39,0h2a.76.76,0,0,0,.75-.75V.75A.75.75,0,0,0,54,0ZM7.53,19.42h5.52a1.5,1.5,0,0,0,1.5-1.5V15.8a.58.58,0,0,0,.18,0H53.27v4H1.49v-4H6v2.09A1.5,1.5,0,0,0,7.53,19.42ZM7,17.92V4a.5.5,0,0,1,.5-.5h5.52a.5.5,0,0,1,.5.5V17.92a.5.5,0,0,1-.5.5H7.53A.5.5,0,0,1,7,17.92ZM53.27,1.49V13.94H14.73a.57.57,0,0,0-.18,0V4a1.5,1.5,0,0,0-1.5-1.5H7.53A1.5,1.5,0,0,0,6,4v9.9H1.49V1.49Zm-47.13,21a2.39,2.39,0,0,1-2.06-1.17H8.2A2.39,2.39,0,0,1,6.14,22.49Zm7.91,0A2.41,2.41,0,0,1,12,21.32h4.13A2.42,2.42,0,0,1,14.05,22.49Zm26.32,0a2.39,2.39,0,0,1-2.06-1.17h4.12A2.39,2.39,0,0,1,40.37,22.49Zm7.92,0a2.42,2.42,0,0,1-2.07-1.17h4.13A2.42,2.42,0,0,1,48.29,22.49Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.79",
    y: "5.17",
    width: "29.52",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "46.27",
    y: "5.17",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.73",
    y: "4.17",
    width: "5.12",
    height: "9.24",
    rx: "2.5"
  }));
};

exports["default"] = _default;